import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Datetime from '@/components/core/DatePicker';
import { CFSwitch } from '../../../basic/Toggle/Toggle';
import Constants from '../../../../Constants';
import { Box, Button, HStack, VStack, Flex } from '@chakra-ui/react';

const propTypes = {
  invoicingOffice: PropTypes.string,
  isSearching: PropTypes.bool,
  onChangeFilter: PropTypes.func,
  onSearch: PropTypes.func,
  grinderReceivedEndDate: PropTypes.string,
  grinderReceivedStartDate: PropTypes.string,
};

const USInvoicingFilters = ({
  invoicingOffice,
  isSearching,
  onChangeFilter,
  onSearch,
  grinderReceivedEndDate,
  grinderReceivedStartDate,
}) => {
  return (
    <VStack gap="30px" align="stretch">
      <Flex gap="63px">
        <Box>
          <label style={{marginBottom:"10px", display:"inline-block"}}>Grinder Received Date:</label>
          <HStack>
            <Datetime
              id="grinder-received-start-date"
              inputProps={{
                placeholder: 'Select date',
                className: 'form-control',
              }}
              closeOnSelect
              value={grinderReceivedStartDate && moment(grinderReceivedStartDate, 'YYYY-MM-DD')}
              onChange={e => {
                const momentDate = moment(e && e?.target ? e.target.value : e);
                if (momentDate?._isAMomentObject) {
                  onChangeFilter('grinderReceivedStartDate', momentDate?.format('YYYY-MM-DD'));
                } else {
                  onChangeFilter('grinderReceivedStartDate', moment(e && e.target ? e.target.value : e));
                }
              }}
              timeFormat={false}
              dateFormat="YYYY-MM-DD"
            />
            <span> to </span>

            <Datetime
              id="grinder-received-end-date"
              inputProps={{
                placeholder: 'Select date',
                className: 'form-control',
              }}
              closeOnSelect
              value={grinderReceivedEndDate && moment(grinderReceivedEndDate, 'YYYY-MM-DD')}
              onChange={e => {
                const momentDate = moment(e && e?.target ? e.target.value : e);
                if (momentDate?._isAMomentObject) {
                  onChangeFilter('grinderReceivedEndDate', momentDate?.format('YYYY-MM-DD'));
                } else {
                  onChangeFilter('grinderReceivedEndDate', moment(e && e.target ? e.target.value : e));
                }
              }}
              timeFormat={false}
              dateFormat="YYYY-MM-DD"
            />
          </HStack>
        </Box>
        <Box>
          <label style={{marginBottom:"10px", display:"inline-block"}}>Invoicing office:</label>
          <CFSwitch
            onClick={value =>
              onChangeFilter(
                'invoicingOffice',
                value ? Constants.BUSINESS_OFFICES.SYDNEY.value : Constants.BUSINESS_OFFICES.CHICAGO.value
              )
            }
            offText={Constants.BUSINESS_OFFICES.CHICAGO.value}
            onText={Constants.BUSINESS_OFFICES.SYDNEY.value}
            isActive={invoicingOffice === Constants.BUSINESS_OFFICES.SYDNEY.value}
          />
        </Box>
        <Button
          colorScheme="actionSecondary"
          width="141px"
          height="43px"
          fontSize="16px"
          disabled={isSearching}
          onClick={onSearch}
          alignSelf="flex-end"
          marginLeft="auto !important"
        >
          Search
        </Button>
      </Flex>
    </VStack>
  );
};

USInvoicingFilters.propTypes = propTypes;

export default USInvoicingFilters;